import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

import { UserRouteAccessService } from '../../shared';
import { SettingsComponent } from './settings.component';

export const monCompteRoute: Route = {
    path: 'mon-compte',
    component: SettingsComponent,
    data: {
        needAuthentication: true,
        pageTitle: `Mon compte${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};

export const settingsRoute: Route = {
    path: 'mon-profil',
    component: SettingsComponent,
    data: {
        needAuthentication: true,
        pageTitle: `Mon compte${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/settings/settings.route.ts